.sql_field_height_140 {
  height: 140px;
}

.sql_field_height_280 {
  height: 280px;
}
